import { z } from 'zod';

export const phaseProgressDtoSchema = z.object({
  phaseCode: z.string(),
  mandatoryDone: z.number().int().nonnegative(),
  mandatoryTotal: z.number().int().nonnegative(),
  recommendedDone: z.number().int().nonnegative(),
  recommendedTotal: z.number().int().nonnegative(),
  progressPercent: z.number().min(0).max(100),
});

export const siteProgressDtoSchema = z.object({
  site: z.object({
    id: z.string().uuid(),
    name: z.string(),
  }),
  sitePhaseCode: z.string(),
  userPhaseCode: z.string(),
  completedTaskCodes: z.array(z.string()),
  perPhase: z.array(phaseProgressDtoSchema),
});

export const toggleTaskInputSchema = z.object({
  completed: z.boolean(),
});

export type PhaseProgressDto = z.infer<typeof phaseProgressDtoSchema>;
export type SiteProgressDto = z.infer<typeof siteProgressDtoSchema>;
export type ToggleTaskInput = z.infer<typeof toggleTaskInputSchema>;
